// import React from 'react'

// const CreateMeasuringUnits = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default CreateMeasuringUnits

import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  TextField,
  Box,
  Breadcrumbs,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  IconButton,
  Link,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { SETTING_API_01, SETTING_API_05 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import SnackbarMessage from "../../components/common/SystemAlert";
import { useSelector } from "react-redux";
import { externalpostApi } from "../../services/externalApis";
import { useLocation } from "react-router-dom";
import SystemAlert from "../../components/common/SystemAlert";

function CreateMeasuringUnits() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const {   LOCCODE,STAFFMAPLOCODE, RESTCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
  const isEdit = location.state?.actionText === "Edit";

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    immeasuringunit: "",
    descrip: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
       
        immeasuringunit: selectedItem.immeasuringunit,
        descrip: selectedItem.descrip,
    immeasuringunitcode: selectedItem.immeasuringunitcode,
      });
    }
  }, [selectedItem]);

 console.log("Selected Item Details:", selectedItemDetails);

 const handleCancel = () => {
  setSelectedItemDetails({
    immeasuringunit: "",
    descrip: "",
  });

};

  useEffect(() => {
    setPageData({
      title: "Measuring Unit",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const goBackToView = () => {
    navigate("/vCreateMeasuringUnits");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
  
    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }
  
    // Validate max length
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }
  
    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }
  
    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleInputChangedes = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
  
    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }
  

  
    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }
  
    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_05, "get", {
          COMPCODE,
            LOCCODE:STAFFMAPLOCODE,


          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleConfirmClick = async () => {
    setIsButtonDisabled(true);
    const { immeasuringunit } = selectedItemDetails;

    const requiredFields = [
      { name: "immeasuringunit", value: immeasuringunit, label: " Measuring Unit Name" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      const errorMessage = `Please Fill All the Required Fields.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
      setIsButtonDisabled(false);
      return;
    }

    if (data) {
      const isDuplicate = data.some((item) => {
        if (
          item.immeasuringunitcode !== selectedItemDetails.immeasuringunit &&
          item.immeasuringunit.toLowerCase() === immeasuringunit.toLowerCase()
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setAlertMessage("Measuring Unit Already Exists.");
        setAlertType("warning");

        setAlertOpen(true); // Open the alert
        return;
      }
    }

    const BRAND_CODE = selectedItem ? (selectedItem.immeasuringunitcode) : 0;
    console.log("Brand Code:", BRAND_CODE);

    const staticValues = {
      COMPCODE,
        LOCCODE:STAFFMAPLOCODE,


      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      immeasuringunitcode: BRAND_CODE,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTING_API_05, payload);
      console.log("Success:", responseData);
      setAlertMessage(
        `${isEdit ? "Updated Successfully!" : "Created Successfully!"}`
      );
      setAlertType("success");

      setAlertOpen(true);
      setSelectedItemDetails({
        immeasuringunit: "",
        descrip:""
      });
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
    setTimeout(() => {
      navigate("/vCreateMeasuringUnits");
    }, 2000);
  };

  return (
    <>
      <Box sx={styles.box_breadcrumb}>
        <Tooltip title="Back to All Items" arrow sx={styles.breadcrumb_tooltip}>
          <IconButton
            aria-label="back"
            sx={styles.btn_breadcrumb_back}
            onClick={goBackToView}
          >
            <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
          </IconButton>
        </Tooltip>
        <Typography sx={styles.breadcrumb_divider}>|</Typography>

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            sx={styles.breadcrumb_link}
            underline="hover"
            // href=""
          >
            Settings
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
     Measuring unit
          </Link>
        </Breadcrumbs>
      </Box>
      <Box sx={styles.box_add_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 8, sm: 10, md: 10, lg: 10, xl: 10 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>  {isEdit ? "Edit Measuring Units" : "Create Measuring Units"}</Typography>
            </Grid>
          </Grid>
        </AppBar>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={styles.add_form_page_container}
        >
          <Grid container spacing={2} sx={styles.add_form_page_grid_container}>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="brand-name"
                label="Measuring Unit"
                variant="outlined"
                fullWidth
                size="small"
                required
                   name="immeasuringunit"
                value={selectedItemDetails.immeasuringunit}
                onChange={handleInputChange}
                error={!!error.immeasuringunit}
                helperText={error.immeasuringunit}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}></Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="description"
                label="Description"
                variant="outlined"
                fullWidth
                size="small"
                name="descrip"
                value={selectedItemDetails.descrip}
                onChange={handleInputChangedes}
                error={!!error.descrip}
                helperText={error.descrip}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
          </Grid>
        </Box>
        <Box sx={styles.add_form_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
            onClick={handleCancel}
        
          >
              Clear
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
            disabled={isButtonDisabled}
            onClick={handleConfirmClick}
          >
           {isEdit ? "Modify" : "Confirm"}
          </Button>
      
        </Box>

        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
      </Box>
    </>
  );
}

export default CreateMeasuringUnits;
